/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".values[_ngcontent-%COMP%]{padding:1.5rem 1rem;display:grid;grid-template-columns:repeat(3,1fr);align-items:center}.lg-container[_ngcontent-%COMP%]{padding:1rem}.divider[_ngcontent-%COMP%]{background-color:#fafafa;padding:.5rem 0}.divider[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{margin-left:1rem;color:#a4a4a4}"];
export { styles as styles };
